/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'ai-mate.chat-error-banner.description': 'История чата сохраняется до 30 дней.',
  'ai-mate.chat-error-banner.title': 'Начать новый чат',
  'ai-mate.chat-error.description': 'Попробуйте <btn>перезагрузить чат</btn>.',
  'ai-mate.chat-error.rate-limited-description':
    'Достигнуто максимальное количество запросов. Повторите попытку позже.',
  'ai-mate.chat-error.rate-limited-title': 'Слишком много запросов',
  'ai-mate.chat-error.rovo-inactive-description': 'Похоже, Rovo не включен на сайте. <link>Настройка Rovo</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo неактивен',
  'ai-mate.chat-error.title': 'Мы не знаем, что пошло не так',
  'ai-mate.main-chat.close-chat-button-label': 'Закрыть',
  'ai-mate.main-chat.maximize-chat-button-label': 'На весь экран',
  'ai-mate.main-chat.minimize-chat-button-label': 'Восстановить представление',
  'ai-mate.main-chat.new-chat-button-label': 'Новое',
  'ai-mate.main-chat.new-chat-button-label-full-screen': 'Новый чат',
  'conversation-assistant-button.label': 'Чат',
  'conversation-assistant-button.rovo-chat-label': 'Чат Rovo',
  'highlight-actions.rovo-chat-custom-prompt-submit-button.text': 'Отправить',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Спросите об этом AI',
  'highlight-actions.rovo-chat-explain-option.text': 'Объяснить',
  'highlight-actions.rovo-chat-explain-prompt':
    'Объясни текст. Для этого перефразируй его и добавь дополнительные сведения. Пиши очень простым языком, используй короткие предложения и приведи примеры или определения всех технических терминов из исходного текста.',
  'highlight-actions.rovo-chat-find-resources-option.text': 'Найти ресурсы',
  'highlight-actions.rovo-chat-find-resources-prompt':
    'Найди в знаниях организации ресурсы, которые подтверждают сделанные заявления.',
  'highlight-actions.rovo-chat-give-examples-option.text': 'Привести примеры',
  'highlight-actions.rovo-chat-give-examples-prompt':
    'Приведи примеры из ресурсов организации или общедоступных знаний. Если ресурсов нет, приведи метафорический пример, который поможет лучше понять суть.',
  'highlight-actions.rovo-chat-give-feedback-option.text': 'Оставить отзыв',
  'highlight-actions.rovo-chat-give-feedback-prompt':
    'Проверь формулировки и дай отзыв. Прокомментируй выбор слов, грамматику и пунктуацию. Проявляй доброжелательность и энтузиазм, но обязательно отметь хотя бы один момент, который можно улучшить или изменить.',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Рекомендации чата',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Открыть чат',
  'highlight-actions.rovo-chat-summarize-option.text': 'Создать сводку',
  'highlight-actions.rovo-chat-summarize-prompt':
    'Выдели главное. Сделай акцент важной информации и исключи ненужные детали. Дай краткий обзор в одном абзаце.',
  'highlight-actions.rovo-chat.button-text': 'Чат',
  'highlight-actions.rovo-chat.button-text-ask-in-chat': 'Задать вопрос в чате',
  'horizontal-scroll-container.scroll-left': 'Прокрутить влево',
  'horizontal-scroll-container.scroll-right': 'Прокрутить вправо',
};
